












import { Component, Vue, Watch } from 'vue-property-decorator';
import Navbar from '@/components/Navbar.vue';
import gql from 'graphql-tag';
import { setInterval, clearInterval } from 'timers';
import store from '@/store';

@Component({
  components: {
    Navbar,
  },
  watch: {
    $route() {
      (this as App).toggleNav();
    },
    user() {
      const user = (this as App).user;
      const isSystemAdmin = !!user && user.role.toLowerCase() === 'system_admin';
      store.dispatch('auth/setIsSystemAdmin', isSystemAdmin);
    },
  },
  apollo: {
    health: {
      query: gql`{ health }`,
      error(e) {
        /* tslint:disable-next-line no-console */
        console.warn(`Error connecting to the API: ${e}`);
        this.hasConnectionIssues = true;
      },
    },
    user: {
      query: gql`
        query User {
          user {
            id
            role
            centers {
              centerId
              isAdmin
            }
          }
        }
      `,
      skip() {
        return !store.getters['auth/authenticated'];
      },
    },
  },
})
export default class App extends Vue {
  public hideNav: boolean = false;
  public adminNav: boolean = false;
  public hasConnectionIssues: boolean = false;
  public health: any = null;
  public user: {
    id: string,
    role: 'user' | 'system_admin' | 'center_admin',
    centers: Array<{ centerId: string, isAdmin: boolean }> | null,
  } | null = null;

  private healthTimer: NodeJS.Timer | null = null;

  public created() {
    this.toggleNav();

    if (this.$store.getters.isAdminMode && !this.$store.getters['auth/authenticated']) {
      return this.$router.push('/');
    }
  }

  public mounted() {
    if (!this.healthTimer) {
      this.healthTimer = setInterval(() => this.$apollo.queries.health.refresh(), 10 * 1000);
    }
  }

  public beforeDestroy() {
    if (this.healthTimer) {
      clearInterval(this.healthTimer);
      this.healthTimer = null;
    }
  }

  public toggleNav() {
    if (this.$route.meta.hideNav) {
      this.hideNav = true;
    } else {
      this.hideNav = false;
    }
    this.adminNav = this.$route.meta.adminNav || false;
  }

  @Watch('health')
  public onHealthChanged() {
    this.hasConnectionIssues = !this.health;
  }
}
